import {http} from '../../plugins/http';

export default {
    index() {
        return http.get(`/api/v1/timers/task-work-timer/index`);
    },

    /**
     * @param {string} taskKey
     */
    show(taskKey) {
       return http.get(`/api/v1/timers/task-work-timer/${taskKey}/show`);
    },

    /**
     * @param {string} taskKey
     */
    start(taskKey) {
        return http.post(`/api/v1/timers/task-work-timer/${taskKey}/start`);
    },

    /**
     * @param {string} taskWorkTimerKey
     */
    stop(taskWorkTimerKey) {
       return http.patch(`/api/v1/timers/task-work-timer/${taskWorkTimerKey}/stop`);
    },

    /**
     * @param {string} taskWorkTimerKey
     */
    resume(taskWorkTimerKey) {
        return http.patch(`/api/v1/timers/task-work-timer/${taskWorkTimerKey}/resume`);
    },

    /**
     * @param {string} taskWorkTimerKey
     */
    complete(taskWorkTimerKey) {
        return http.patch(`/api/v1/timers/task-work-timer/${taskWorkTimerKey}/complete`);
    },

    /**
     * @param {string} taskWorkTimerKey
     */
    cancel(taskWorkTimerKey) {
        return http.delete(`/api/v1/timers/task-work-timer/${taskWorkTimerKey}/cancel`);
    },
};



// WEBPACK FOOTER //
// ./src/services/Timers/TaskWorkTimerController.js